import { render, staticRenderFns } from "./my-address.vue?vue&type=template&id=fd557a94&"
import script from "./my-address.vue?vue&type=script&lang=js&"
export * from "./my-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports